import React from 'react';
import './courseCountHover.css'

function C2wCourseCountHover( {obj} ) {
  return (
    <div className='C2wCourseCountHover'>
          <span>{`${obj?.count}`}</span>
          {`${obj?.heading}`}
    </div>
  )
}

export default C2wCourseCountHover;
